export const FOOTER_NAMES = {
	STUDIO_7: 'Studio 7',
	SERVICES: 'Services',
	INFORMATION: 'Information',
};
